import React, { useContext, useState } from 'react';
import { Alert, Checkbox, Typography } from '@one-thd/sui-atomic-components';
import { FormControlLabel, FormGroup } from '@material-ui/core';
import { ReturnError, ReturnCheckBoxError, ModalButtonGroup } from '../commons';
import { NationalAccountContext } from '../../../../../contexts';
import { modalBlurbs, shared } from '../../../../../constants/NationalAccount';

const GovtAffiliationDescription = () => {
  return (
    <div className="sui-rounded-md sui-px-4">
      <Alert status="warning">
        <div>
          <Typography variant="body-base" data-testid="agreementHeader">
            {modalBlurbs.governmentBlurbs.warning.line1}
          </Typography>
          <ul className="sui-pl-6 sui-pt-1 sui-list-disc">
            <li className="sui-pb-1">
              <Typography variant="body-base">
                {modalBlurbs.governmentBlurbs.warning.line2}
              </Typography>
            </li>
            <li className="sui-pb-1">
              <Typography variant="body-base">
                {modalBlurbs.governmentBlurbs.warning.line3}
              </Typography>
            </li>
          </ul>
          <Typography variant="body-base">
            {modalBlurbs.governmentBlurbs.warning.line4}
          </Typography>
        </div>
      </Alert>
    </div>
  );
};

export const GovernmentAffiliationWarningModal = (): JSX.Element => {
  const { setValidResponseState, errorState, setErrorState, setShowModal } =
    useContext<any>(NationalAccountContext);
  const [isChecked, setChecked] = useState(false);
  const [isCheckedErrorState, setCheckedErrorState] = useState(false);

  const handleChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    if (!isChecked) setCheckedErrorState(false);
    setChecked(event.target.checked);
  };

  const cancelAgreement = () => {
    setErrorState(false);
    setShowModal(false);
    setValidResponseState((prevState: any) => {
      return {
        ...prevState,
        enrollState: true,
        requiredEINState: false,
        einGovState: false,
      };
    });
  };

  const validateResponse = () => {
    if (isChecked) {
      setValidResponseState((prevState: any) => {
        return { ...prevState, einGovState: false };
      });
    } else {
      setErrorState(true);
    }
  };
  return (
    <div className="sui-flex sui-flex-col sui-justify-start sui-align-center sui-text-base">
      <GovtAffiliationDescription />
      <div>
        <div className="sui-py-4 sui-px-2">
          <FormGroup>
            <FormControlLabel
              control={
                <div style={{ alignSelf: 'start' }}>
                  <Checkbox
                    checked={isChecked}
                    onChange={handleChange}
                    size="large"
                  />
                </div>
              }
              label={
                <Typography variant="body-base" className="sui-pt-2">
                  {modalBlurbs.governmentBlurbs.warning.line5}
                </Typography>
              }
            />
          </FormGroup>
          {isCheckedErrorState && <ReturnCheckBoxError />}
        </div>
        {errorState && <ReturnError />}
        <ModalButtonGroup
          disabled={!isChecked}
          cb={validateResponse}
          confirmBlurb={shared.continue}
          handleClose={cancelAgreement}
          cancelBlurb={shared.cancel}
        />
      </div>
    </div>
  );
};
